module.exports = Package['ivadey:slingshot'];